import React from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { Container } from '@fiverr-private/layout_components';
import {
    imageStyleEn,
    imageStyleFr,
    imageStylePor,
    imageStyleDu,
    imageStyleGr,
    imageStyleIt,
    imageStyleSp,
    emptyStyle,
} from './FiverrAdLbll.ve.css';

const styleMap = {
    'en-US': imageStyleEn,
    'fr-FR': imageStyleFr,
    'de-DE': imageStyleGr,
    es: imageStyleSp,
    'pt-BR': imageStylePor,
    'it-IT': imageStyleIt,
    'nl-NL': imageStyleDu,
};

interface FiverrAdLblProps {
    isPromoted: boolean;
}
export const FiverrAdLbl = ({ isPromoted }: FiverrAdLblProps) => {
    const { locale } = getContext();
    const style = isPromoted ? styleMap[locale] || imageStyleEn : emptyStyle;
    return <Container as="span" className={style} />;
};
